import { useAuthUser } from '@hub/auth';
import type React from 'react';
import { BannerProvider } from './BannerProvider';

export function AuthenticatedBannerProvider({ children }: { children: React.ReactNode }) {
  const userHandle = useAuthUser()?.userHandle ?? null;
  return <BannerProvider userHandle={userHandle}>{children}</BannerProvider>;
}
